import { Injectable } from '@angular/core';

declare global {
  interface Window { dataLayer: any[]; gtag?: (...args: any[]) => void; }
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private measurementId = '';
  private initialized = false;

  async init(measurementId: string) {
    this.measurementId = measurementId;

    if (window.gtag) {
      // Host site already has gtag.js, just configure our property
      window.gtag('config', this.measurementId, { send_page_view: false });
      this.initialized = true;
      return;
    }

    // Load gtag.js dynamically
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;

    return new Promise<void>((resolve) => {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      script.onload = () => {
        window.gtag!('js', new Date());
        window.gtag!('config', measurementId, { send_page_view: false });
        this.initialized = true;
        resolve();
      };
      document.head.appendChild(script);
    });
  }

  trackEvent(name: string, params: Record<string, any> = {}) {
    if (!this.initialized || !window.gtag) return;
    window.gtag('event', name, { ...params, send_to: this.measurementId });
  }

  trackPageView(url?: string, title?: string) {
    if (!this.initialized || !window.gtag) return;
    window.gtag('event', 'page_view', {
      page_location: url || window.location.href,
      page_title: title || document.title,
      page_path: new URL(url || window.location.href).pathname,
      send_to: this.measurementId,
    });
  }

  setUserId(userId: string) {
    if (!this.initialized || !window.gtag) return;
    window.gtag('set', { user_id: userId });
  }

  setUserProperties(props: Record<string, any>) {
    if (!this.initialized || !window.gtag) return;
    window.gtag('set', { user_properties: props });
  }
}
